import React, { Component } from 'react';
import ResultEntry from './ResultEntry';
import Headline from './Headline';
import './results.css';

export default class Results extends Component {
	constructor(props) {
		super(props);
		this.state = {"hits": [], "error": false, "devs": []};
		this.index = props.index;
		let date = new Date();
		this.latestGameTime = (+date) - (60E3 * 60 * 24 * 7)
									  - (60E3 * date.getUTCMinutes()) 
									  - (60E3 * 60 * date.getUTCHours()) 
									  - 60E3;
		this.resultHeadline = {};
		this.devs = [];
	}

	toTitleCase(str) {
		return str.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
	}

	componentWillReceiveProps(nextProps) {
		this.setState({"hits": nextProps.hits, "query": nextProps.query, "onDevsReceived": nextProps.devs});

		if(nextProps.query !== "") {
			document.title = this.toTitleCase(nextProps.query) + ' Livestream - Das deutsche TV Programm bei Livestream.de';
			document.querySelector('meta[name="description"]').setAttribute("content", this.toTitleCase(nextProps.query) + ' livestream und mehr Online TV. Sport und Bundesliga Live, aktuelle News, Unterhaltung oder Kids TV - das deutsche TV Programm Online schauen.');
		}
	}

	render() {
		if (this.state.error) {
			return [
				<div className="inner" key="0">
					Error
				</div>
			];
		}
		let results = [];

		this.state.hits.forEach((row) => {
			results.push(
				<ResultEntry key={row.objectID} {...row} />
			);
		});

		this.resultHeadline.text = "Beliebte Live Streams";
		this.resultTextWording = 'Ergebnisse';

		if(this.state.hits.length === 1) {
			this.resultTextWording = 'Ergebnis';			
		}

		if (this.state.query) {
			this.resultHeadline.text = '"' + this.state.query + '": ' + this.state.hits.length + ' ' + this.resultTextWording;
		}

		return [
			<h3 className="hide" key="0">Results</h3>,
			<div className="inner" key="1">
				<Headline text={this.resultHeadline.text} />
				<ul>{results}</ul>
			</div>
		];
	}
}


// WEBPACK FOOTER //
// ./src/Results.js